var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('landing-create', {
    attrs: {
      "content": _vm.content
    }
  }), _vm.attributes ? _c('view-component', {
    attrs: {
      "attributes": _vm.attributes
    }
  }) : _vm._e(), _c('loader', {
    staticClass: "loading-overlay",
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), this.hideFreezer ? _c('div', _vm._l(_vm.freezerData.shelves, function (shelf, shelfIndex) {
    return _c('v-row', {
      key: shelfIndex,
      staticClass: "border-style shelves"
    }, [_c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('v-card', [_c('v-card-title', {
      staticClass: "d-flex align-center justify-space-between",
      on: {
        "click": function ($event) {
          return _vm.toggleShelf(shelfIndex);
        }
      }
    }, [_c('div', {
      staticClass: "shelf-title"
    }, [_vm._v(" Shelf No. " + _vm._s(shelf.shelfNo || shelfIndex + 1) + " ")]), _c('v-icon', [_vm._v(" " + _vm._s(_vm.openShelves.includes(shelfIndex) ? 'mdi-chevron-up' : 'mdi-chevron-down') + " ")])], 1), _c('v-card-text', [_c('v-expand-transition', [_vm.openShelves.includes(shelfIndex) ? _c('v-row', _vm._l(shelf.contents, function (column, colIndex) {
      var _column$type;

      return _c('v-col', {
        key: column._id || colIndex,
        attrs: {
          "cols": "12",
          "md": _vm.getColumnSize(shelf)
        }
      }, [_c('v-card', {
        staticClass: "column-card",
        class: ("column-" + ((_column$type = column.type) === null || _column$type === void 0 ? void 0 : _column$type.toLowerCase())),
        on: {
          "click": function ($event) {
            return _vm.viewColumn(column, shelf);
          }
        }
      }, [_c('div', {
        staticClass: "column-header"
      }, [_c('v-icon', {
        staticClass: "mr-1",
        attrs: {
          "small": ""
        }
      }, [_vm._v(" " + _vm._s(_vm.getColumnIcon(column.type)) + " ")]), _c('span', [_vm._v("Column " + _vm._s(column.columnNo))]), _c('v-spacer'), _c('v-icon', {
        staticClass: "action-icon",
        attrs: {
          "small": ""
        },
        on: {
          "click": function ($event) {
            $event.stopPropagation();
            return _vm.viewColumn(column);
          }
        }
      }, [_vm._v(" mdi-information-outline ")])], 1), _c('div', {
        staticClass: "column-body"
      }, [column.type === 'Empty' ? _c('div', {
        staticClass: "empty-state"
      }, [_c('v-icon', {
        attrs: {
          "size": "40"
        }
      }, [_vm._v("mdi-close-circle-outline")]), _c('div', [_vm._v("Empty")])], 1) : column.type === 'Box' ? _c('div', {
        staticClass: "box-state",
        on: {
          "click": function ($event) {
            $event.stopPropagation();
            return _vm.openBox(column, shelf);
          }
        }
      }, [_c('div', {
        staticClass: "box-state clickable"
      }, [_c('v-icon', {
        attrs: {
          "size": "40"
        }
      }, [_vm._v("mdi-package-variant-closed")]), _c('div', {
        staticClass: "mt-2 font-weight-bold"
      }, [_vm._v(" " + _vm._s(column.name || 'Box Storage') + " ")]), _c('div', {
        staticClass: "text-caption mt-1"
      }, [_vm._v(" Click to manage boxes ")])], 1)]) : column.type === 'Rack' ? _c('div', {
        staticClass: "rack-physical"
      }, [_c('div', {
        staticClass: "rack-header"
      }, [_c('v-icon', {
        attrs: {
          "size": "36"
        }
      }, [_vm._v("mdi-view-stream")]), _c('div', {
        staticClass: "font-weight-bold ml-2"
      }, [_vm._v(" " + _vm._s(column.name || 'Rack') + " ")])], 1), _c('div', {
        staticClass: "rack-body"
      }, _vm._l(Number(column.slidingRacksNo), function (i) {
        return _c('div', {
          key: i,
          staticClass: "rack-drawer",
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.openSlidingRack(column, shelf, i);
            }
          }
        }, [_c('div', {
          staticClass: "drawer-left"
        }, [_vm._v(" " + _vm._s(i) + " ")]), _c('div', {
          staticClass: "drawer-center"
        }, [_vm._v(" Sliding Rack " + _vm._s(i) + " ")]), _c('div', {
          staticClass: "drawer-right"
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-chevron-right")])], 1)]);
      }), 0)]) : column.type === 'Others' ? _c('div', {
        staticClass: "others-state"
      }, [_c('div', {
        staticClass: "others-wrapper"
      }, [_c('v-icon', {
        attrs: {
          "size": "40"
        }
      }, [_vm._v("mdi-dots-horizontal-circle-outline")]), _c('div', {
        staticClass: "mt-2 font-weight-bold"
      }, [_vm._v(" " + _vm._s(column.name || 'Others') + " ")]), _c('div', {
        staticClass: "text-caption mt-1"
      }, [_vm._v(" " + _vm._s(column.notes || 'No additional configuration') + " ")])], 1)]) : _c('div', {
        staticClass: "other-state"
      }, [_c('v-icon', [_vm._v("mdi-dots-horizontal-circle-outline")]), _c('div', [_vm._v("Unassigned")])], 1)])])], 1);
    }), 1) : _vm._e()], 1)], 1)], 1)], 1)], 1);
  }), 1) : _vm._e(), _vm.showSlidingRack || _vm.showBoxView ? _c('div', {
    staticClass: "sliding-rack-body"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "return-btn",
    attrs: {
      "block": ""
    },
    on: {
      "click": function ($event) {
        return _vm.returnToShelf();
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "blue"
    }
  }, [_vm._v(" mdi-arrow-left-circle-outline ")]), _vm._v(" Return ")], 1), _vm.activeLocation.activeRackNo ? _c('v-breadcrumbs', {
    attrs: {
      "items": [{
        text: ("Shelf No. " + (_vm.activeLocation.activeShelfNo))
      }, {
        text: ("Rack No. " + (_vm.activeLocation.activeRackNo))
      }, {
        text: ("Sliding Rack No. " + (_vm.activeLocation.activeSlidingRackNo))
      }]
    },
    scopedSlots: _vm._u([{
      key: "divider",
      fn: function () {
        return [_c('v-icon', [_vm._v("mdi-forward")])];
      },
      proxy: true
    }, {
      key: "item",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('span', [_vm._v(_vm._s(item.text))])];
      }
    }], null, false, 65604067)
  }) : _c('v-breadcrumbs', {
    attrs: {
      "items": [{
        text: ("Shelf No. " + (_vm.activeBoxContext.shelf.shelfNo))
      }, {
        text: ("Column No. " + (_vm.activeBoxContext.column.columnNo))
      }]
    },
    scopedSlots: _vm._u([{
      key: "divider",
      fn: function () {
        return [_c('v-icon', [_vm._v("mdi-forward")])];
      },
      proxy: true
    }, {
      key: "item",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('span', [_vm._v(_vm._s(item.text))])];
      }
    }], null, false, 65604067)
  })], 1)], 1), _vm.renderBoxes.length ? _c('v-row', [_c('v-col', {
    staticClass: "d-flex justify-center align-center freezer-indicator",
    attrs: {
      "cols": "12"
    }
  }, [_c('label', [_vm._v("BACK SIDE")])])], 1) : _vm._e(), _vm._l(_vm.renderBoxes, function (renderBox) {
    return _c('v-row', {
      key: renderBox.id + '-' + (renderBox.selectedId || ''),
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "contents"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('v-card', [_c('v-card-title', [_c('div', {
      staticClass: "box-label"
    }, [_vm._v(_vm._s(renderBox.name))])]), _c('v-card-text', [renderBox ? _c('table', {
      staticClass: "box-table"
    }, [_c('tr', _vm._l(_vm.validNumber(renderBox.noOfColumn) + 1, function (col) {
      return _c('th', {
        key: col,
        staticClass: "box-location"
      }, [col - 1 !== 0 ? _c('div', [_vm._v(" " + _vm._s(_vm.boxLocationInitial[col - 2]) + " ")]) : _vm._e()]);
    }), 0), _vm._l(_vm.validNumber(renderBox.noOfRows), function (row, vertical) {
      return _c('tr', {
        key: vertical,
        staticClass: "box-row"
      }, [vertical + 1 !== 0 ? _c('th', {
        staticClass: "box-location"
      }, [_vm._v(_vm._s(vertical + 1))]) : _vm._e(), _vm._l(_vm.validNumber(renderBox.noOfColumn), function (col) {
        return _c('td', {
          key: col,
          staticClass: "box-column"
        }, _vm._l(_vm.specimens, function (specimen) {
          return _c('div', {
            key: specimen.code
          }, [_vm.boxLocationInitial[col - 1] + row === specimen.location.boxLocation && _vm.activeLocation.activeShelfNo.toString() === specimen.location.shelfNumber.toString() && _vm.activeLocation.activeRackNo.toString() === specimen.location.rackNumber.toString() && _vm.activeLocation.activeSlidingRackNo.toString() === specimen.location.slidingRackNumber.toString() && specimen.location.boxNumber === renderBox.id ? _c('div', {
            staticClass: "truncate-text"
          }, [_c('v-tooltip', {
            attrs: {
              "right": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function (_ref3) {
                var on = _ref3.on,
                    attrs = _ref3.attrs;
                return [_c('v-btn', _vm._g(_vm._b({
                  attrs: {
                    "block": "",
                    "color": "primary"
                  },
                  on: {
                    "click": function ($event) {
                      return _vm.onEdit(specimen);
                    }
                  }
                }, 'v-btn', attrs, false), on), [_c('b', [_vm._v(_vm._s(specimen.code))])])];
              }
            }], null, true)
          }, [_c('strong', [_vm._v("Code:")]), _vm._v(" " + _vm._s(specimen.code)), _c('br'), _c('strong', [_vm._v("Case Number:")]), _vm._v(" " + _vm._s(specimen.caseNumber ? specimen.caseNumber._id.caseNumber : 'N/A')), _c('br'), _c('strong', [_vm._v("Specimen Source:")]), _vm._v(" " + _vm._s(specimen.specimenSource ? specimen.specimenSource : 'N/A')), _c('br'), _c('strong', [_vm._v("Type:")]), _vm._v(" " + _vm._s(specimen.specimenType.name)), _c('br'), _c('strong', [_vm._v("State:")]), _vm._v(" " + _vm._s(specimen.specimenState.name)), _c('br'), _c('strong', [_vm._v("Collecting Institution:")]), _vm._v(" " + _vm._s(specimen.siteOfCollection ? specimen.siteOfCollection.name : 'N/A')), _c('br'), specimen.siteOfCollection ? _c('div', [_c('strong', [_vm._v("Province:")]), _vm._v(" " + _vm._s(specimen.province)), _c('br'), _c('strong', [_vm._v("Region:")]), _vm._v(" " + _vm._s(specimen.region)), _c('br')]) : _vm._e(), _c('strong', [_vm._v("Note:")]), _vm._v(" " + _vm._s(specimen.note ? specimen.note : 'N/A')), _c('br'), _c('strong', [_vm._v("Box Location:")]), _vm._v(" " + _vm._s(specimen.location.boxLocation) + " ")])], 1) : _vm._e()]);
        }), 0);
      })], 2);
    })], 2) : _vm._e()]), _c('v-card-actions', [_c('v-btn', {
      attrs: {
        "text": "",
        "color": "primary"
      },
      on: {
        "click": function ($event) {
          return _vm.removeBox(renderBox);
        }
      }
    }, [_vm._v(" Remove ")])], 1)], 1)], 1)], 1)]);
  }), _vm.renderBoxes.length ? _c('v-row', [_c('v-col', {
    staticClass: "d-flex justify-center align-center freezer-indicator",
    attrs: {
      "cols": "12"
    }
  }, [_c('label', [_vm._v("FRONT SIDE")])])], 1) : _vm._e(), _c('v-card', {
    staticClass: "mt-5"
  }, [_c('v-card-title', [_vm._v(" Add Box ")]), _c('v-card-text', [_c('v-select', {
    key: _vm.boxWithLocation.join(','),
    ref: "select",
    attrs: {
      "items": _vm.boxOptions,
      "item-text": "name",
      "item-value": "_id",
      "label": "Select a Box",
      "return-object": "",
      "single-line": "",
      "filled": "",
      "clearable": "",
      "dense": "",
      "hide-no-data": "",
      "filter": ""
    },
    on: {
      "update:modelValue": _vm.setBoxData
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('v-list-item', {
          key: item._id,
          attrs: {
            "disabled": _vm.boxWithLocation.some(function (bwl) {
              return bwl === item._id;
            })
          },
          on: {
            "click": function ($event) {
              return _vm.handleSelect(item);
            }
          }
        }, [_c('v-list-item-title', [_vm._v(" " + _vm._s(item.name) + " ")])], 1)];
      }
    }], null, false, 738159953),
    model: {
      value: _vm.selectedBox,
      callback: function ($$v) {
        _vm.selectedBox = $$v;
      },
      expression: "selectedBox"
    }
  })], 1), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.confirmBox(_vm.selectedBox);
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 2) : _vm._e(), _c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: _vm.columnDialog,
      callback: function ($$v) {
        _vm.columnDialog = $$v;
      },
      expression: "columnDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "d-flex align-center"
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v(" mdi-information-outline ")]), _vm._v(" Column Details ")], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "dialog-label"
  }, [_vm._v(" Name ")]), _c('div', {
    staticClass: "dialog-value"
  }, [_vm._v(" " + _vm._s(_vm.selectedColumn.name || 'N/A') + " ")])]), _c('div', [_c('div', {
    staticClass: "dialog-label"
  }, [_vm._v(" Notes ")]), _c('div', {
    staticClass: "dialog-value"
  }, [_vm._v(" " + _vm._s(_vm.selectedColumn.notes || 'No notes available') + " ")])])]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.columnDialog = false;
      }
    }
  }, [_vm._v(" Close ")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }